// extracted by mini-css-extract-plugin
export default {"box":"PasswordEdit_box__6WnEk","buttons":"PasswordEdit_buttons__dczxt"};